import { useTranslation } from 'next-i18next';
import S from './ErrorBadge.module.scss';
export const ErrorBadge = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div className={S.error_badge} data-sentry-component="ErrorBadge" data-sentry-source-file="ErrorBadge.tsx">{t('subscription:SpaceList.tag.fail')}</div>;
};